import React from "react";
import ContentLoader from "../../components/contentLoader";
import styles from "./press.module.scss";

export default function Press() {
  return (
    <div className={`contentContainer ${styles.pressWrapper}`}>
      <ContentLoader docName={"press"} />
    </div>
  );
}
